<template>
  <div class="text-nowrap">
    <entity-edit-control :entity="entity" :entity-name="entityName" />
    <span>&nbsp;</span>
    <entity-delete-control :entity="entity" :entity-name="entityName" :refs="refs" />
  </div>
</template>

<script type="text/babel">
import EntityEditControl from "./EntityEditControl.vue";
import EntityDeleteControl from "./EntityDeleteControl.vue";

export default {
  components: {
    EntityEditControl,
    EntityDeleteControl,
  },
  props: ["entity", "entityName", "refs"],
};
</script>
